const OUTPUT_FORMAT = 'image/jpeg';
function b64ToUint8Array(b64Image) {
    const img = atob(b64Image.split(',')[1]);
    const buffer = [];
    let i = 0;
    while (i < img.length) {
        buffer.push(img.charCodeAt(i));
        i++;
    }
    return new Uint8Array(buffer);
}
export function base64ToBlob(b64) {
    const u8Image = b64ToUint8Array(b64);
    return new Blob([u8Image], { type: OUTPUT_FORMAT });
}
